import { useGetCustomGEOJSONStorageInfo, useGetCustomGeoJsonList } from "@/api/hooks/customGeojson";
import { classNames } from "@/utility/jsx";
import { t } from "@lingui/core/macro";
import { useMemo } from "react";
import styles from "./style.module.scss";

export function GeoJSONInfoSection() {
  const { data } = useGetCustomGEOJSONStorageInfo();
  const isStorageFull = data?.total_size_mb !== undefined && data.total_size_mb >= data.limit_mb;
  const { list: customGeoJsonList } = useGetCustomGeoJsonList(true);

  const backgroundStyle = useMemo(() => {
    if (!data?.total_size_mb || (data.total_size_mb <= 0 && data.limit_mb)) {
      return undefined;
    }

    const percent = Math.min((data.total_size_mb / data.limit_mb) * 100, 100);
    let color = "#00365221";

    if (percent > 80) {
      color = "#f5656521";
    } else if (percent > 50) {
      color = "#dbb42121";
    }

    return {
      background: `linear-gradient(to right, ${color} ${percent}%, #FFF ${percent}%)`,
    };
  }, [data?.limit_mb, data?.total_size_mb]);

  return (
    <div className={styles.geojson__section}>
      <div className={styles["geojson__info-wrapper"]}>
        <div className={styles["geojson__info-label"]}>
          <div className={styles["geojson__info-heading"]}>{t`Manage your GeoJSON files`}</div>
          <div className={styles["geojson__info-subheading"]}>
            {t`Upload your GeoJSON files quickly and securely to visualize and process spatial data.`}
          </div>
        </div>
        <div className={styles["geojson__info-value"]} style={backgroundStyle}>
          <div>
            <span className={classNames("material-icons", styles["geojson__cloud-icon"])}>cloud_queue</span>
          </div>
          <div className={styles.geojson__storage}>
            <div>{t`Total used space`}</div>
            <div className={styles["geojson__storage-values"]}>
              <div data-testid="storage-usage" className={styles["geojson__storage-files-size"]}>
                {data?.total_size_mb ? data?.total_size_mb.toFixed(2).toString() : "-"}/
                {data?.limit_mb ? data?.limit_mb : "-"} MB
              </div>
              <div className={styles["geojson__storage-files-amount"]}>
                {!customGeoJsonList && "-"}
                {customGeoJsonList &&
                  (customGeoJsonList.length === 0 || customGeoJsonList.length > 1) &&
                  t`${customGeoJsonList.length} files`}
                {customGeoJsonList && customGeoJsonList.length === 1 && t`${customGeoJsonList.length} file`}
              </div>
            </div>
            {isStorageFull && <div>{t`Storage full, please delete some files`}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
